import { Row, Typography } from "antd";
import styled from "styled-components";

export const GoBackWrapper = styled(Row)`
  cursor: pointer;
  width: fit-content;

  .title {
    margin: 0;
  }

  svg {
    height: 24px;
    width: 24px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`;

export const StyledText = styled(Typography.Text)`
  color: ${"#8c8c8c"};
  font-weight: 500;
  margin-left: 40px;
`;
